import React, { createContext, useState, useEffect, useCallback, useMemo } from 'react';
import { jwtDecode } from 'jwt-decode'

import Swal from "sweetalert2";


export const AuthContext = createContext();

const AuthContextProvider = (props) => {
  const [token, setToken] = useState('')
  const [isAuth, setIsAuth] = useState(false)
  const [user, setUser] = useState({})

  const loginUser = useCallback((token)=>{
    localStorage.setItem('app_token', token)
    const decoded = jwtDecode(token)
    setToken(token)
    setIsAuth(true)
    setUser(decoded)
  }, [])

  const logoutUser = useCallback((user)=>{
    localStorage.removeItem('app_token')
    setToken({})
    setIsAuth(false)
    setUser(null)
  }, [])

  const salir = useCallback(()=>{
    const token = localStorage.getItem('app_token')
    let dateNow = Math.floor(Date.now()/1000)
    const decoded = jwtDecode(token)
    let timexp = decoded.exp
    if (dateNow >= timexp){
      localStorage.removeItem('app_token')
      setToken({})
      setIsAuth(false)
      setUser(null)
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Tu sesion ha caducado",
        showConfirmButton: false,
        timer: 2000,
      });
      setTimeout(() => {
        window.location.href = '/login'
      }, 1000);
    }
  }, [])
  

  useEffect(()=>{
    const item = localStorage.getItem('app_token')
    if (item){
      const decoded = jwtDecode(item)
      setToken(item)
      setIsAuth(true)
      setUser(decoded)
      salir()
    }
  }, [salir])

  const contextValue = useMemo(() => ({
    token,
    isAuth,
    user,
    loginUser,
    logoutUser,
  }), [token, isAuth, user, loginUser, logoutUser])

  return (
        <AuthContext.Provider value={contextValue}>
      { props.children }
    </AuthContext.Provider>
  )
};

export default AuthContextProvider;